import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Collapse, TableCell, TableRow, Tooltip } from '@mui/material';

import OnDeleteIcon from '../../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../../icons/OnEditIcon';
import { formatDate } from '../../../../utils/dateFunctions';

import HealthIncidentRowDetails from './HealthIncidentRowDetails';

import table from '../../../../commonStyles/tables.module.css';
import tableRow from './healthIncident.module.css';

const styles = {
    paddingBottom: 0,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    borderTop: 'none',
    borderBottom: 'none'
};

const HealthIncidentRow = ({
    row,
    isDisabled,
    isDeleteDisabled,
    onEdit,
    onDelete,
    toggleDropdown,
    openId
}) => {
    const [toolTipContent, setToolTipContent] = useState('');

    useEffect(() => {
        if (row.eventTypes.length <= 1 && toolTipContent) setToolTipContent('');
        else if (row.eventTypes.length > 1) {
            const formatContent = (el, i) => <div key={`${el}-${i}`}>{el}</div>;
            setToolTipContent(row.eventTypes.map((el) => formatContent(el)));
        }
    }, [row.eventTypes]);

    const onToggleDropdown = () => toggleDropdown(openId === row.id ? '' : row.id);

    return (
        <>
            <TableRow
                key={row.id}
                hover
                className={`${table.tableRowStripes} ${table.canOpen}`}
                onClick={onToggleDropdown}>
                <TableCell>{formatDate(row.eventDate)}</TableCell>
                <TableCell>
                    {!toolTipContent ? (
                        row.eventTypes.length ? (
                            row.eventTypes[0]
                        ) : (
                            ' - '
                        )
                    ) : (
                        <span>
                            <Tooltip title={toolTipContent} placement="top">
                                <span>{row.eventTypes[0]}...</span>
                            </Tooltip>
                        </span>
                    )}
                </TableCell>
                <TableCell>
                    <span className={tableRow.alignRow3}>
                        {formatDate(row.dateReportedToNhse) ?? ' - '}
                    </span>
                </TableCell>
                <TableCell>
                    <span className={tableRow.alignRow45}>
                        {formatDate(row.programmeDeIntensifiedDate) ?? ' - '}
                    </span>
                </TableCell>
                <TableCell>
                    <span className={tableRow.alignRow45}>
                        {formatDate(row.programmeReIntensifiedDate) ?? ' - '}
                    </span>
                </TableCell>
                <TableCell align="right" id="editIcon">
                    <OnEditIcon onEdit={(e) => onEdit(e, row)} active={!isDisabled} />
                </TableCell>
                <TableCell align="right">
                    <OnDeleteIcon onDelete={() => onDelete(row)} active={!isDeleteDisabled} />
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={styles} colSpan={7}>
                    <Collapse in={openId === row.id} timeout="auto" unmountOnExit>
                        <HealthIncidentRowDetails row={row} onClose={onToggleDropdown} />
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

HealthIncidentRow.propTypes = {
    row: PropTypes.object,
    isDisabled: PropTypes.bool,
    isDeleteDisabled: PropTypes.bool,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    toggleDropdown: PropTypes.func,
    openId: PropTypes.string
};

export default HealthIncidentRow;
